import React from "react";


const Overlay2 = ({ onClose }) => {
  return <div className="overlay" onClick={onClose}></div>;
};

export default Overlay2;